import { render, staticRenderFns } from "./importarNotaAdmin.vue?vue&type=template&id=0e7ee672"
import script from "./importarNotaAdmin.vue?vue&type=script&lang=js"
export * from "./importarNotaAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports